export const reportRetentionsExistsTypes = {
  SET_RETENTIONS_EXISTS_FILTERS: 'SET_RETENTIONS_EXISTS_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
